import { COMMON_SSO_ACCESS_TOKEN } from "../constants/sso";
import { logPageActionToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import { getLoginState } from "@repo/shared-utils/insert-params";
import { request } from "../core/request";
import { API_RESPONSE_CODES, BFL_WHEELES_ERROR, OPERATION_IDS } from "./constants";
import { ISolarInsertApiRequest, ISolarInsertApiResponse } from "../types/solarInsertTypes";

export const solarInsert = async (
  data: ISolarInsertApiRequest
): Promise<ISolarInsertApiResponse> => {
  try {
    const response = (await request({
      operationId: OPERATION_IDS.solarInsert,
      requestData: { ...data },
    })) as ISolarInsertApiResponse;

    if (response.statusCode !== API_RESPONSE_CODES.STATUS_CODE_7001) {
      throw new Error(JSON.stringify(response));
    }

    return response;
  } catch (error) {
    logPageActionToNewRelic(BFL_WHEELES_ERROR, {
      component: "Solar Insert",
      pageUrl: typeof window !== "undefined" ? window.location.href : "",
      message: (error as Error).message,
      debugInfo: JSON.stringify({
        loginState: getLoginState(),
        hasAToken: typeof window !== "undefined" && !!localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
        hasMobile: !!data.mobileNo,
      }),
    });
    return {} as ISolarInsertApiResponse;
  }
};
